"use strict";

module.exports = function (url) {
    window.history.pushState({
        url: url || window.location.href.split(window.location.hostname)[1],
        random: Math.random(),
        source: "swup"
    }, document.getElementsByTagName('title')[0].innerText, url || window.location.href.split(window.location.hostname)[1]);
};


//////////////////
// WEBPACK FOOTER
// /home/giant/builds/t1_QpaSbS/0/kpmg/plan-k.cz/node_modules/swup/lib/modules/createState.js
// module id = 40
// module chunks = 3